import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { StatusPanel } from "../components/StatusPanel";
import { Turnstile } from "../components/Turnstile";
import { invokeFunction, isBackendConfigured } from "../lib/supabase";

export function DataRequestPage() {
  const { type = "export" } = useParams();
  const requestType = type === "deletion" ? "deletion" : "export";
  const [email, setEmail] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");
  const [error, setError] = useState("");

  async function submit() {
    if (!email.includes("@")) return setError("Enter the email used for your account or application.");
    setState("busy");
    setError("");
    try {
      if (isBackendConfigured) {
        await invokeFunction(`request-data-${requestType}`, { email, turnstileToken });
      }
      setState("done");
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : "Could not send the request.");
      setState("idle");
    }
  }

  return (
    <div className="public-page">
      <PublicHeader />
      <main id="main-content" className="legal-shell">
        <span className="eyebrow">YOUR DATA</span>
        <h1>{requestType === "export" ? "Get a copy of your data." : "Ask us to delete your data."}</h1>
        <p>Enter the same email you used with Middlemen & Co. We will verify the request before we act.</p>
        {state === "done" ? (
          <StatusPanel title="Request received" message="We will verify your email and update you inside the app or by email." kind="success" />
        ) : (
          <>
            <label><span>Email</span><input className="field" type="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
            {error && <StatusPanel title="Check your request" message={error} kind="error" />}
            <Turnstile onToken={setTurnstileToken} />
            <button className="btn primary" disabled={state === "busy"} onClick={submit}>{state === "busy" ? "SENDING…" : "SEND REQUEST"}</button>
          </>
        )}
        <Link className="btn" to="/legal/privacy">READ PRIVACY NOTICE</Link>
      </main>
    </div>
  );
}
